import * as React from "react";
import { Alert, Button } from "antd";
import { Inbox } from "react-feather";
import styles from "../NGProviderBrowser.module.scss";

interface BrowserEmptyProps {
  error?: string;
  onRetry?: () => void;
}

export const BrowserEmpty: React.FC<BrowserEmptyProps> = React.memo(({ error, onRetry }) => {
  if (error) {
    return (
      <div className={styles.emptyContainer}>
        <Alert
          type="error"
          className={styles.errorAlert}
          message="Error"
          description={error}
          action={
            onRetry ? (
              <Button size="small" onClick={onRetry}>
                Retry
              </Button>
            ) : undefined
          }
        />
      </div>
    );
  }

  return (
    <div className={styles.emptyContainer}>
      <Inbox className={styles.emptyIcon} size={48} />
      <span className={styles.emptyText}>No Items Found</span>
    </div>
  );
});

BrowserEmpty.displayName = "BrowserEmpty";
